import { render, staticRenderFns } from "./QuerySummary.vue?vue&type=template&id=4e739df8&"
import script from "./QuerySummary.vue?vue&type=script&lang=ts&"
export * from "./QuerySummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports